import { render, staticRenderFns } from "./BlockchainDashboard.vue?vue&type=template&id=4e258c8d"
import script from "./BlockchainDashboard.vue?vue&type=script&lang=js"
export * from "./BlockchainDashboard.vue?vue&type=script&lang=js"
import style0 from "./BlockchainDashboard.vue?vue&type=style&index=0&id=4e258c8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports